import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "3D renderations",
  "description": "",
  "published": "2007-01-25T00:00:00.000Z",
  "redirect_from": ["/blog/3d-renderations/swizec/307"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Someone's recently showed me `}<a parentName="p" {...{
        "href": "http://hof.povray.org/"
      }}>{`this website`}</a>{`, which is full of quite amazing examples of 3D computer art, probably the best I've ever had the pleasure of seeing.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      